export default __webpack_public_path__ + "static/media/expozy_no_code.8938960c.png";